module.exports = __webpack_public_path__ + "static/media/terminal_no_water.1d1d971c.png";